export const LANDING_PAGE_CMS_DATA = "/apim-admin";
export const GRAPHQL_PROXY = "api/graphql-proxy";
export const USER_BASE_URL = "https://app-apim-admin-cms-stage-erhsf2bafdenc7ft.australiasoutheast-01.azurewebsites.net/";